import React, { Component } from 'react';

import moment from 'moment-with-locales-es6';
import { connect} from "remx";
import broker from '../../../utils/broker';

import dataStore from '../../../stores/data';
import DataTable from '../../../components/DataTable';

class TableTraffic extends Component {
    constructor(props) {
        super(props);
    
        this.options = {
          sortIndicator: true,
          hideSizePerPage: true,
          paginationSize: 6,
          hidePageListOnlyOnePage: true,
          clearSearch: true,
          alwaysShowAllBtns: false,
          withFirstAndLast: false
        }
        this.state = {
          reload:false,
          loading: false,
          id_pk_column: 'id',
          url: { url_get_data : '/tr_bandwidth', url_save_data: '/tr_bandwidth', url_update_data: '/tr_bandwidth',
                 url_delete_data: '/tr_bandwidth', url_get_data_per: '/tr_bandwidth' },
          title: '',
          title_add : '', 
          fields: null, 
          columns: [ 
            // { header: 'id', id: 'id', accessor: 'id', child_accessor: null, className: 'text-center'},
            { header: 'Nama Kategori', id: 'nama_kategori', accessor: 'nama_kategori', child_accessor: null, className: 'text-center'},
            { header: 'Nama Pelanggan', id: 'nama_pelanggan', accessor: 'nama_pelanggan', child_accessor: null, className: 'text-center'},
            { header: 'Tanggal', id: 'tanggal', accessor: 'tanggal', child_accessor: null,
                Cell: row => {
                    return `${moment(row.value).locale('id').format('DD MMMM YYYY')}`;
                }
            },
            { header: 'Jam', id: 'jam', accessor: 'tanggal', child_accessor: null,
                Cell: row => {
                    return `${moment(row.value).locale('id').format('HH:mm')}`;
                }
            },
            { header: 'Download Rate', id: 'download_rate', accessor: 'download_rate', child_accessor: null,
                Cell: row => {
                    return `${row.value} Mbps`;
                }
            },
            { header: 'Upload Rate', id: 'upload_rate', accessor: 'upload_rate', child_accessor: null,
                Cell: row => {
                    return `${row.value} Mbps`;
                }
            },
            { header: 'Option', id: 'option', accessor: 'option', child_accessor: null,
                Cell: row => {
                    return <button className="btn btn-xs pd-x-10 btn-outline-dark btn-uppercase mg-l-5" onClick={()=> this.deleteData(row.row)}>
                                <i className="fa fa-trash"></i>
                            </button>;
                }
            },
            
        ],
        }
        this.deleteData = this.deleteData.bind(this);
      }

      deleteData(row){
          if (this.props.type_view === 'day') {
              this.deleteHour(row.id)
          } else {
              this.deleteDay(row.pelanggan_id, row.tanggal)
          }
      }

      deleteHour(id){
        broker.fetch.delete(`/bandwidth_delete_hour?id=${id}`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                dataStore.setters.setReloadTable(true);
            } else {

            }
        }).catch(err => {

        });
      }

      deleteDay(pelanggan_id, date){
        broker.fetch.delete(`/bandwidth_delete_day?pelanggan_id=${pelanggan_id}&date=${date}`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                dataStore.setters.setReloadTable(true);
            } else {

            }
        }).catch(err => {

        });
      }



    render(){
        // console.log(this.props.pelanggan_id)
        return(
            <DataTable
                    columns={this.state.columns} 
                    url={this.state.url} 
                    title={this.state.title} 
                    title_add={this.state.title_add} 
                    fields={this.state.fields} 
                    id_pk={null} 
                    add_form={false}
                    id_pk_column={this.state.id_pk_column}
                    style_container={'content'}
                    column_option={false}
                    custom_query={'id='+this.props.pelanggan_id
                                        +'&type='+this.props.type_view
                                        +'&date='+(moment(this.props.date_view).locale('id').format('YYYY-MM-DD'))
                                        +'&year='+(moment(this.props.date_view).locale('id').format('YYYY'))
                                        +'&month='+(this.props.month_view+1)}
            />
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
    }
}


export default connect(mapStateToProps)(TableTraffic);